import styles from "./TableOfContents.module.css";

export default function TableOfContents({
  // title = "On this page",
  items = [],
}) {
  if (!items.length) return null;

  return (
    <nav
      className={styles.toc}
      // aria-label={title}
    >
      {/* <h2 className={styles.heading}>
        {title}
      </h2> */}

      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={styles.link}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}